import React, { useEffect, useState } from 'react';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';
import { IQuestion } from '@/components/staffer/Grading/types';
import { applyGradeByStudentFilters } from '@/components/staffer/Grading/utils';
import QuestionCard from './QuestionCards/QuestionCard';

const CardContainer = () => {
  const {
    assignment,
    questionAnswers,
  } = useGradingStore();
  const { questions } = assignment;
  const [filteredQuestions, setFilteredQuestions] = useState<IQuestion[]>(questions);
  const { filters } = useGradingStore.getState();
  const { autoGradedFilter, questionsFilter, statusFilter } = filters;

  useEffect(() => {
    if (!questions) return;

    setFilteredQuestions(applyGradeByStudentFilters({
      autoGradedFilter,
      questionAnswers,
      questions,
      questionsFilter,
      statusFilter,
    }));
  }, [autoGradedFilter, questionAnswers, questions, questionsFilter, statusFilter]);

  return (
    <>
      {filteredQuestions.map((q) => {
        const questionAnswer = questionAnswers?.find(qa => qa.question_id === q.id);

        return (
          <QuestionCard
            key={q.id}
            question={q}
            questionAnswer={questionAnswer}
          />
        );
      })}
    </>
  );
};

export default CardContainer;
